import { useQuery } from 'react-query';
import { getDataFromLocalStorage } from 'src/localStorage/getDataFromLocalStorage';
import { QueryKey } from 'src/reactQuery/enums/queryKey.enum';
import { fetchUsers } from 'src/services/napi/users/fetchUsers';
import { LocalStorageKey } from 'src/localStorage/enums/localStorageKey.enum';
import { useNotification } from '../../../providers/notificationsProvider';

const fetchUsersFn = async () => {
  const currentProject = getDataFromLocalStorage(LocalStorageKey.CURRENT_PROJECT);
  if (!currentProject) {
    return [];
  }

  const { _id: projectId } = currentProject;
  const data = await fetchUsers(projectId);
  return data?.users;
};

export const useFetchUsers = () => {
  const { notify } = useNotification();

  return useQuery([QueryKey.USERS], () => fetchUsersFn(), {
    keepPreviousData: true,
    onError: () => {
      notify({ message: 'Error Loading data... Try again later', severity: 'error' });
    },
    placeholderData: []
  });
};
